import api from "@/api";
import DataResponse from "@/types/DataResponse";
import RecoveryMethod from "@/types/RecoveryMethod";

export default async function getPasswordRecoveryMethods(document: string): Promise<RecoveryMethod[]> {
  const response = await api.post<DataResponse<RecoveryMethod[]>>("/api/password/search", { document: document.replace(/[^A-Z0-9]/gi, "") });

  return response.data.data;
}
